import {BasePopup} from "components/popup"
import {PracticalClinicExportFameTable} from "./PracticalClinicExportFameTable"
import {GradesExportFameTable} from "./GradesExportFameTable"
import {PracticalAndGradesErrorLogType} from "../AcademicErrorLogView/AcademicErrorLogView"
import styles from "./PracticalIssues.module.css"

type Props = {
    isShow: boolean
    onClose: () => void
    type: PracticalAndGradesErrorLogType
}

export function PracticalIssuesPopup(props: Props) {
    const {isShow, onClose, type} = props

    return (
        <BasePopup isShow={isShow} onClose={onClose} leftIcon="GRID_FILL" width="90vw" destroyOnClose>
            <div style={{padding: 12}}>
                <p className={styles.popupTitle}>
                    {type === PracticalAndGradesErrorLogType.Practical
                        ? "Practical - Clinic"
                        : "Grades - Export (Fame)"}
                </p>
                <div className={styles.divisor} />
                {type === PracticalAndGradesErrorLogType.Practical ? (
                    <PracticalClinicExportFameTable />
                ) : (
                    <GradesExportFameTable />
                )}
            </div>
        </BasePopup>
    )
}
